import React from "react";
import { SpaceProps } from "styled-system";
import { ContactPreferencesConfig } from "../../../../../types/ContactConfig";
import { ContactDetailsContactPreferences } from "../../../ContactDetailsContactPreferences";
import { ContactDetails } from "../../../../../types/ContactDetailsValues";
import { MOBILE_REG_EXP } from "../../../../../constants/ContactNumbersRegex";

interface Props {
  idPrefix: string;
  namePrefix: string;
  contactPreferenceConfig: ContactPreferencesConfig;
  contact: ContactDetails;
}

export const NewContactPreference: React.FC<Props & SpaceProps> = ({
  idPrefix,
  namePrefix,
  contactPreferenceConfig,
  contact,
}) => {
  const shouldDisableEmailPreference =
    contactPreferenceConfig.emailDisabled || contact.email === "";
  const shouldDisableSmsPreference =
    contactPreferenceConfig.smsDisabled ||
    !contact.mobile ||
    !MOBILE_REG_EXP.test(contact.mobile);

  return (
    <ContactDetailsContactPreferences
      id={idPrefix}
      name={`${namePrefix}.${contactPreferenceConfig.contactPreferenceType}`}
      title={contactPreferenceConfig.title}
      emailLabel={contactPreferenceConfig.emailLabel}
      smsLabel={contactPreferenceConfig.smsLabel}
      emailDisabled={shouldDisableEmailPreference}
      smsDisabled={shouldDisableSmsPreference}
      focusable={true}
      mb={4}
    />
  );
};
